import { FaqSection } from '~/components/FaqSection';
import UserReviews from '../LandingPage/components/UserReviews';
import { useState } from 'react';

const TickSVG = () => {
    return (
        <svg
            className='w-5 h-5 mx-auto'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 20 20'
            fill='currentColor'>
            <path
                fillRule='evenodd'
                d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                clipRule='evenodd'></path>
        </svg>
    );
};

export const Pricing = () => {
    const [isAnnual, setIsAnnual] = useState(true);

    const cycleName = isAnnual ? 'annually' : 'month';
    const proPrice = isAnnual ? '$99.99' : '$19.99';
    const premiumPrice = isAnnual ? '$299.99' : '$39.99';
    const proPaymentLink = isAnnual
        ? '/subscription/pro/annual'
        : '/subscription/pro';
    const premiumPaymentLink = isAnnual
        ? '/subscription/premium/annual'
        : '/subscription/premium';

    return (
        <section id='pricing' className='py-10 bg-white sm:py-16 lg:py-24'>
            <div className='px-4 mx-auto max-w-7xl sm:px-6 lg:px-8'>
                <div className='max-w-xl mx-auto text-center'>
                    <h1 className='text-4xl font-bold text-black lg:text-5xl sm:text-5xl'>
                        Pricing &amp; Plans
                    </h1>
                    <p className='mt-4 text-lg leading-relaxed text-gray-600'>
                        Start for free and use across all Office 365 apps.
                        <br />
                        Buy a subscription to unlock premium features.
                    </p>
                </div>

                <div className='flex items-center justify-center mt-4 space-x-6 sm:mt-6'>
                    <div className='flex items-center '>
                        <input
                            type='radio'
                            id='monthly'
                            name='pricing-plans'
                            className='cursor-pointer w-4 h-4 text-blue-600 border border-gray-200 focus:ring-1 focus:outline-none focus:ring-blue-600'
                            checked={!isAnnual}
                            onClick={(e) => {
                                setIsAnnual(!e.target.checked);
                            }}
                        />
                        <label
                            htmlFor='monthly'
                            className='cursor-pointer block pl-3 text-sm font-medium text-gray-900 sm:text-base'>
                            {' '}
                            Monthly
                        </label>
                    </div>

                    <div className='flex items-center cursor-pointer'>
                        <input
                            type='radio'
                            id='yearly'
                            checked={isAnnual}
                            name='pricing-plans'
                            onClick={(e) => {
                                setIsAnnual(e.target.checked);
                            }}
                            className='cursor-pointer w-4 h-4 text-blue-600 border border-gray-200 focus:ring-1 focus:outline-none focus:ring-blue-600'
                        />
                        <label
                            htmlFor='yearly'
                            className='cursor-pointer block pl-3 text-sm font-medium text-gray-900 sm:text-base'>
                            {' '}
                            Annually
                            <span className='ml-1 text-sm font-medium text-blue-600'>
                                {' '}
                                (Save more than 60% 🥳){' '}
                            </span>
                        </label>
                    </div>
                </div>
                <div className='hidden mt-16 lg:block'>
                    <table className='w-full'>
                        <thead>
                            <tr>
                                <th className='py-8 pr-4'></th>
                                <th className='px-4 py-8 text-center'>
                                    <span className='text-base font-medium text-blue-600 uppercase'>
                                        {' '}
                                        Pro{' '}
                                    </span>
                                    <p className='mt-6 text-6xl font-bold'>
                                        {proPrice}
                                    </p>
                                    <p className='mt-2 text-base font-normal text-gray-500'>
                                        / {cycleName}
                                    </p>
                                </th>

                                <th className='px-4 py-8 text-center bg-gray-900 rounded-t-xl'>
                                    <span className='px-4 py-2 inline-flex items-center justify-center text-base font-medium text-white bg-blue-600 rounded-full'>
                                        <span className='uppercase'>
                                            Premium
                                        </span>
                                        <span className='ml-1 text-xs'>
                                            ✨ Most popular ✨
                                        </span>
                                    </span>
                                    <p className='mt-6 text-6xl font-bold text-white'>
                                        {premiumPrice}
                                    </p>
                                    <p className='mt-2 text-base font-normal text-gray-200'>
                                        / {cycleName}
                                    </p>
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td className='py-4 pr-4 font-medium border-b border-gray-200'>
                                    Monthly Token Limit
                                </td>

                                <td className='px-4 py-4 text-center border-b border-gray-200'>
                                    100 tokens
                                </td>

                                <td className='px-4 py-4 text-center text-white bg-gray-900 border-b border-white/20'>
                                    3,000 tokens
                                </td>
                            </tr>

                            <tr>
                                <td className='py-4 pr-4 font-medium border-b border-gray-200'>
                                    ChatGPT version
                                </td>

                                <td className='px-4 py-4 text-center border-b border-gray-200'>
                                    4.0
                                </td>

                                <td className='px-4 py-4 text-center text-white bg-gray-900 border-b border-white/20'>
                                    4.0-omega
                                </td>
                            </tr>

                            <tr>
                                <td className='py-4 pr-4 font-medium border-b border-gray-200'>
                                    Query Limits
                                </td>

                                <td className='px-4 py-4 text-center border-b border-gray-200'>
                                    Standard
                                </td>

                                <td className='px-4 py-4 text-center text-white bg-gray-900 border-b border-white/20'>
                                    Extended
                                </td>
                            </tr>

                            <tr>
                                <td className='py-4 pr-4 font-medium border-b border-gray-200'>
                                    Full Integration with Office 365
                                </td>

                                <td className='px-4 py-4 text-center border-b border-gray-200'>
                                    <TickSVG />
                                </td>

                                <td className='px-4 py-4 text-center text-white bg-gray-900 border-b border-white/20'>
                                    <TickSVG />
                                </td>
                            </tr>
                            <tr>
                                <td className='py-4 pr-4 font-medium border-b border-gray-200'>
                                    Full Integration with Telegram
                                </td>

                                <td className='px-4 py-4 text-center border-b border-gray-200'>
                                    <TickSVG />
                                </td>

                                <td className='px-4 py-4 text-center text-white bg-gray-900 border-b border-white/20'>
                                    <TickSVG />
                                </td>
                            </tr>
                            <tr>
                                <td className='py-4 pr-4 font-medium border-b border-gray-200'>
                                    Chrome Extension
                                </td>

                                <td className='px-4 py-4 text-center border-b border-gray-200'>
                                    <TickSVG />
                                </td>

                                <td className='px-4 py-4 text-center text-white bg-gray-900 border-b border-white/20'>
                                    <TickSVG />
                                </td>
                            </tr>

                            <tr>
                                <td className='py-4 pr-4 font-medium border-b border-gray-200'>
                                    Regular Updates
                                </td>

                                <td className='px-4 py-4 text-center border-b border-gray-200'>
                                    <TickSVG />
                                </td>

                                <td className='px-4 py-4 text-center text-white bg-gray-900 border-b border-white/20'>
                                    <TickSVG />
                                </td>
                            </tr>
                            <tr>
                                <td className='py-4 pr-4 font-medium border-b border-gray-200'>
                                    Professional Support
                                </td>

                                <td className='px-4 py-4 text-center border-b border-gray-200'>
                                    Unavailable
                                </td>

                                <td className='px-4 py-4 text-center text-white bg-gray-900 border-b border-white/20'>
                                    <TickSVG />
                                </td>
                            </tr>
                            <tr>
                                <td className='py-6 pr-4'></td>

                                <td>
                                    <a
                                        href={proPaymentLink}
                                        target='_blank'
                                        rel='noreferrer'
                                        className='w-full justify-center  text-center px-4 py-6 inline-flex items-center font-semibold'>
                                        Subscribe
                                        <svg
                                            className='w-4 h-4 ml-1'
                                            xmlns='http://www.w3.org/2000/svg'
                                            viewBox='0 0 20 20'
                                            fill='currentColor'>
                                            <path
                                                fillRule='evenodd'
                                                d='M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z'
                                                clipRule='evenodd'></path>
                                        </svg>
                                    </a>
                                </td>

                                <td className='text-white bg-yellow-500 rounded-b-xl'>
                                    <a
                                        href={premiumPaymentLink}
                                        target='_blank'
                                        rel='noreferrer'
                                        className='w-full px-4 py-6 justify-center text-center inline-flex items-center font-semibold text-white'>
                                        Subscribe
                                        <svg
                                            className='w-4 h-4 ml-1'
                                            xmlns='http://www.w3.org/2000/svg'
                                            viewBox='0 0 20 20'
                                            fill='currentColor'>
                                            <path
                                                fillRule='evenodd'
                                                d='M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z'
                                                clipRule='evenodd'></path>
                                        </svg>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className='block mt-12 border-t border-b border-gray-200 divide-y divide-gray-200 lg:hidden'>
                <div className='grid grid-cols-2 text-center divide-x divide-gray-200'>
                    <div className='px-1 py-2 sm:px-4'>
                        <span className='text-sm font-medium text-blue-600 uppercase'>
                            Pro{' '}
                        </span>
                        <p className='mt-2 text-xl font-bold'>{proPrice}</p>
                        <span className='mt-1 text-sm font-normal text-gray-500'>
                            / {cycleName}{' '}
                        </span>
                        <a
                            href={proPaymentLink}
                            target='_blank'
                            rel='noreferrer'
                            className='flex items-center justify-center w-full px-1 py-2 mt-5 text-sm text-white transition-all duration-200 bg-blue-600 border border-transparent rounded-md hover:bg-blue-700'
                            role='button'>
                            Subscribe
                        </a>
                    </div>

                    <div className='px-1 py-2 sm:px-4'>
                        <span className='text-sm font-medium text-blue-600 uppercase'>
                            Premium{' '}
                        </span>
                        <p className='mt-2 text-xl font-bold'>{premiumPrice}</p>
                        <span className='mt-1 text-sm font-normal text-gray-500'>
                            / {cycleName}{' '}
                        </span>
                        <a
                            href={premiumPaymentLink}
                            target='_blank'
                            rel='noreferrer'
                            className='flex items-center justify-center w-full px-1 py-2 mt-5 text-sm text-white transition-all duration-200 bg-blue-600 border border-transparent rounded-md hover:bg-blue-700'
                            role='button'>
                            Subscribe
                        </a>
                    </div>
                </div>

                <div className='px-2 py-4 sm:px-4'>
                    <p className='font-semibold'>Daily Token Limit</p>
                </div>

                <div className='grid grid-cols-2 text-center divide-x divide-gray-200'>
                    <div className='px-2 py-2'>100 tokens</div>

                    <div className='px-2 py-2'>3,000 tokens</div>
                </div>

                <div className='px-2 py-4 sm:px-4'>
                    <p className='font-semibold'>ChatGPT version</p>
                </div>

                <div className='grid grid-cols-2 text-center divide-x divide-gray-200'>
                    <div className='px-2 py-2'>4.0</div>

                    <div className='px-2 py-2'>4.0 omega</div>
                </div>

                <div className='px-2 py-4 sm:px-4'>
                    <p className='font-semibold'>Query Limits</p>
                </div>

                <div className='grid grid-cols-2 text-center divide-x divide-gray-200'>
                    <div className='px-2 py-2'>Standard</div>

                    <div className='px-2 py-2'>Extended</div>
                </div>

                <div className='px-2 py-4 sm:px-4'>
                    <p className='font-semibold'>
                        Full Integration with Office 365
                    </p>
                </div>

                <div className='grid grid-cols-2 text-center divide-x divide-gray-200'>
                    <div className='px-2 py-2'>
                        <TickSVG />
                    </div>

                    <div className='px-2 py-2'>
                        <TickSVG />
                    </div>
                </div>

                <div className='px-2 py-4 sm:px-4'>
                    <p className='font-semibold'>
                        Full Integration with Telegram
                    </p>
                </div>

                <div className='grid grid-cols-2 text-center divide-x divide-gray-200'>
                    <div className='px-2 py-2'>
                        <TickSVG />
                    </div>

                    <div className='px-2 py-2'>
                        <TickSVG />
                    </div>
                </div>

                <div className='px-2 py-4 sm:px-4'>
                    <p className='font-semibold'>Chrome Extension</p>
                </div>

                <div className='grid grid-cols-2 text-center divide-x divide-gray-200'>
                    <div className='px-2 py-2'>
                        <TickSVG />
                    </div>

                    <div className='px-2 py-2'>
                        <TickSVG />
                    </div>
                </div>

                <div className='px-2 py-4 sm:px-4'>
                    <p className='font-semibold'>Regular Updates</p>
                </div>

                <div className='grid grid-cols-2 text-center divide-x divide-gray-200'>
                    <div className='px-2 py-2'>
                        <TickSVG />
                    </div>

                    <div className='px-2 py-2'>
                        <TickSVG />
                    </div>
                </div>

                <div className='px-2 py-4 sm:px-4'>
                    <p className='font-semibold'>Professional Support</p>
                </div>

                <div className='grid grid-cols-2 text-center divide-x divide-gray-200'>
                    <div className='px-2 py-2'>Unavailable</div>

                    <div className='px-2 py-2'>
                        <TickSVG />
                    </div>
                </div>

                <div className='grid grid-cols-2 text-center divide-x divide-gray-200'>
                    <div className='px-1 py-2 sm:px-4'>
                        <span className='text-sm font-medium text-blue-600 uppercase'>
                            Pro{' '}
                        </span>
                        <p className='mt-2 text-xl font-bold'>{proPrice}</p>
                        <span className='mt-1 text-sm font-normal text-gray-500'>
                            / {cycleName}{' '}
                        </span>
                        <a
                            href={proPaymentLink}
                            target='_blank'
                            rel='noreferrer'
                            className='flex items-center justify-center w-full px-1 py-2 mt-5 text-sm text-white transition-all duration-200 bg-blue-600 border border-transparent rounded-md hover:bg-blue-700'
                            role='button'>
                            Subscribe
                        </a>
                    </div>

                    <div className='px-1 py-2 sm:px-4'>
                        <span className='text-sm font-medium text-blue-600 uppercase'>
                            Premium{' '}
                        </span>
                        <p className='mt-2 text-xl font-bold'>{premiumPrice}</p>
                        <span className='mt-1 text-sm font-normal text-gray-500'>
                            / {cycleName}{' '}
                        </span>
                        <a
                            href={premiumPaymentLink}
                            rel='noreferrer'
                            target='_blank'
                            className='flex items-center justify-center w-full px-1 py-2 mt-5 text-sm text-white transition-all duration-200 bg-blue-600 border border-transparent rounded-md hover:bg-blue-700'
                            role='button'>
                            Subscribe
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default function Index() {
    return (
        <>
            <Pricing />
            <UserReviews />
            <FaqSection />
        </>
    );
}
